import screeenOne from "./monitor1.jpg";
import screeenTwo from "./monitor2.jpg";
import screenThree from "./monitor3.jpg";
import screenFour from "./monitor4.jpg";
import screenfive from "./monitor5.jpg";
import planograma from "./planograma.png";
import planogramaTablet from "./screenTabletActv1top3.png";

export const imgsTopicThree = {
	screeenOne,
	screeenTwo,
	screenThree,
	screenFour,
	screenfive,
	planograma,
	planogramaTablet,
};
